import React, { useState } from 'react'
import SearchNot from '../../images/searchNot.png'
import { Col, Container, Row } from 'react-bootstrap'

import LastPacketListCard from './LastPacketListCard'
import EmptyReturn from '../EmptyReturn'

const LastPacketList = ({data}) => {
  return (
    <Container className='allCardsCon'>
     <Row style={{width:'100%'}}>
     {
        data?.length?data.map((item,index)=>{
                   
            return <LastPacketListCard key={index} item={item}/>
        })
     :<EmptyReturn/>}
     </Row>
    </Container>
  )
}

export default LastPacketList
